/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.25.0
 * @since 1.25.0
 */

export { KitLoader } from './kitLoader';
